import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { verificationApi, type VerificationStatus } from '../api/verificationApi';
import { ivKeys } from '../queryKeys';
import { isRunning } from '../utils/format';

const POLL_MS = 10_000;

export function useWorklist(status?: VerificationStatus) {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ivKeys.worklist(locationId, status),
    queryFn: () => verificationApi.listVerifications(locationId, status),
    enabled: !!locationId,
    // Keep polling while an electronic check is still running for any row.
    refetchInterval: (q) => {
      const rows = q.state.data;
      return rows?.some((r) => isRunning(r.status)) ? POLL_MS : false;
    },
  });

  function invalidate() {
    queryClient.invalidateQueries({ queryKey: ivKeys.worklistPrefix(locationId) });
    queryClient.invalidateQueries({ queryKey: ivKeys.metrics(locationId) });
  }

  return { ...query, rows: query.data ?? [], locationId, invalidate };
}
